import React, { useEffect, useRef } from 'react';
var MapV2 = function MapV2(_ref) {
  var lat = _ref.lat,
    lng = _ref.lng,
    _ref$zoomControl = _ref.zoomControl,
    zoomControl = _ref$zoomControl === void 0 ? false : _ref$zoomControl,
    _ref$markerIcon = _ref.markerIcon,
    markerIcon = _ref$markerIcon === void 0 ? 'https://statics.olx.in/external/base/img/olxAutos/map-pin.svg' : _ref$markerIcon,
    _ref$infoWindowConten = _ref.infoWindowContent,
    infoWindowContent = _ref$infoWindowConten === void 0 ? '' : _ref$infoWindowConten,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$setZoomEvent = _ref.setZoomEvent,
    setZoomEvent = _ref$setZoomEvent === void 0 ? function () {} : _ref$setZoomEvent,
    _ref$onLoad = _ref.onLoad,
    onLoad = _ref$onLoad === void 0 ? function () {} : _ref$onLoad,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  var mapContainerRef = useRef(null);
  useEffect(function () {
    var mapsApi = window.google.maps;
    if (mapContainerRef.current) {
      var map = new mapsApi.Map(mapContainerRef.current, {
        center: {
          lat: lat,
          lng: lng
        },
        zoom: 13,
        disableDefaultUI: true,
        zoomControl: zoomControl
      });
      if (!map) {
        return;
      }
      if (onLoad) {
        var _ref2 = map.getCenter() || {},
          _lat = _ref2.lat,
          _lng = _ref2.lng;
        if (_lat && _lng) {
          onLoad({
            longitude: _lng(),
            latitude: _lat(),
            map: map
          });
        }
      }
      var markerOptions = {
        map: map,
        position: map.getCenter(),
        draggable: true,
        icon: markerIcon
      };
      var marker = new mapsApi.Marker(markerOptions);
      if (infoWindowContent) {
        var openInfowindow = function openInfowindow() {
          infowindow.open({
            anchor: marker,
            map: map,
            shouldFocus: false
          });
        };
        var infowindow = new mapsApi.InfoWindow({
          content: infoWindowContent
        });
        openInfowindow();
        marker.addListener('click', openInfowindow);
      }
      marker.addListener('dragstart', function () {
        map.set('dragging', true);
      });
      marker.addListener('dragend', function () {
        map.set('dragging', false);
        var pos = marker.getPosition();
        if (pos) {
          map.panTo(pos);
        }
      });
      map.set('marker', marker);
      mapsApi.event.addListenerOnce(map, 'idle', function () {
        map.addListener('dragstart', function () {
          map.set('dragging', true);
        });
        map.addListener('dragend', function () {
          map.set('dragging', false);
          mapsApi.event.trigger(map, 'idle');
        });
        map.addListener('zoom_changed', function () {
          setZoomEvent();
        });
        map.addListener('idle', function () {
          var centre = map.getCenter();
          if (!map.get('dragging') && centre) {
            map.get('marker').setPosition(centre);
            var _centre$toJSON = centre.toJSON(),
              _lat2 = _centre$toJSON.lat,
              _lng2 = _centre$toJSON.lng;
            if (onChange) {
              onChange({
                latitude: _lat2,
                longitude: _lng2
              });
            }
          }
        });
      });
    }
  }, [mapContainerRef]);
  return /*#__PURE__*/React.createElement("div", {
    ref: mapContainerRef,
    className: className
  });
};
export default MapV2;